<template>
  <v-container>
    <div class="display-2 mb-7 mt-5 font-weight-thin" color="primary">
      {{ $tc("entities.item.title", 1) }}
    </div>
    <alert-box v-model="alert.alerts" :type="alert.type"></alert-box>

    <btn-a
      v-if="!noAction"
      rounded
      color="primary"
      @click="editItem"
      :access="$access.item.edit"
    >
      <v-icon>mdi-plus</v-icon>
    </btn-a>

    <table-grid
      :noAction="noAction"
      :multiple="multiple"
      :singleSelect="singleSelect"
      :headers="headers"
      :items="items"
      :loading="loadingTable"
      :loadingAction="loadingDialog"
      :actions="actions"
      :page="pagination.page"
      :pageLength="lengthPaginationComp"
      @input="pagination.page = $event"
      @click="clickTable($event)"
      @search="searchTable"
    />

    <dialog-d
      ref="dialogEdit"
      :title="$tc('entities.item.title', 1)"
      :deleteButton="itemSelected && itemSelected.id"
      @confirm="saveItem(itemSelected, $refs.form.isValid())"
      @delete="deleteItem(itemSelected, true)"
      :loading="loadingDialog"
      :alert="form.alert"
      :accessConfirm="$access.item.edit"
      :accessDelete="$access.item.delete"
      cancelConfirm
    >
      <itemForm
        ref="form"
        v-if="itemSelected"
        v-model="itemSelected"
        :units="units"
      />
    </dialog-d>
  </v-container>
</template>

<script>
import itemService from "@/services/itemService";
import itemForm from "../components/forms/items/itemForm";
import pageListMixing from "../mixins/pageLists/pageListMixing.js";
export default {
  props: {},
  mixins: [pageListMixing],
  components: { itemForm },

  data() {
    return {
      entityService: itemService,
      apiController: "item",
      searchFields: ["code", "description"],
      units: [],
      headers: [
        {
          text: this.$t("entities.item.props.code"),
          align: "left",
          sortable: false,
          value: "code",
        },
        {
          text: this.$t("entities.item.props.description"),
          align: "left",
          sortable: false,
          value: "description",
        },

        {
          text: this.$t("table.actions"),
          value: "action",
          sortable: false,
          align: "right",
        },
      ],
      actions: [
        {
          text: this.$t("edit"),
          icon: "mdi-pencil",
          handle: this.editItem,
          access: [this.$access.item.edit, this.$access.item.show],
        },

        // {
        //   text: this.$tc("entities.version.title", 2),
        //   icon: "mdi-chevron-right",
        //   handle: this.versionPageNavigate,
        //   access: this.$access.version.show
        // },
        {
          text: this.$t("delete"),
          icon: "mdi-delete",
          handle: this.deleteItem,
          access: this.$access.item.delete,
        },
      ],
    };
  },
  methods: {
    versionPageNavigate(item) {
      this.$router.push({ name: "Version", params: { itemId: item.id } });
    },
    async getModelDefault() {
      return {
        code: await this.getAutoInc(this.apiController),
        description: "",
        unitId: "",
        versions: [],
        customFields: {},
      };
    },
    async getUnits() {
      let res = await this.$http.get("unit");
      if (res.success) this.units = res.data.data;
    },
    async getitems() {
      let res = await this.$http.get("item");
      if (res.success) this.items = res.data.data;
    },
  },
  async mounted() {
    await this.getUnits();
    await this.getItems();
  },
};
</script>